import { useEffect, useState } from "react";
import { DownloadSimple, X, DeviceMobile } from "@phosphor-icons/react";

const DISMISS_KEY = "ezitemizer:pwa-install-dismissed";

export default function PWAInstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
      const TWO_WEEKS = 14 * 24 * 60 * 60 * 1000;
      if (Date.now() - dismissedAt < TWO_WEEKS) return;
      setEvt(e);
      setVisible(true);
    };
    const onInstalled = () => {
      setInstalled(true);
      setVisible(false);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || !visible || !evt) return null;

  const onInstall = async () => {
    try {
      await evt.prompt();
      const choice = await evt.userChoice;
      if (choice?.outcome === "dismissed") {
        localStorage.setItem(DISMISS_KEY, String(Date.now()));
      }
    } catch (err) {
      console.warn("PWA install prompt failed", err);
    }
    setVisible(false);
  };

  const onDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  return (
    <div
      data-testid="pwa-install-prompt"
      className="fixed bottom-20 md:bottom-6 left-3 right-3 md:left-auto md:right-6 md:max-w-sm z-[60] bg-[#1A2332] text-zinc-100 border border-[#FF9800] shadow-2xl"
    >
      <div className="flex items-start gap-3 p-4">
        <div className="h-10 w-10 bg-[#FF9800] flex items-center justify-center flex-shrink-0">
          <DeviceMobile size={20} weight="duotone" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#FF9800]">
            Install ezItemizer
          </div>
          <div className="font-display font-bold text-sm sm:text-base mt-1 leading-tight">
            Run it like a native app on the floor
          </div>
          <p className="text-xs text-zinc-400 mt-1">
            Adds an icon to your home screen and works offline so flaky shop-floor wifi never blocks a scan.
          </p>
          <div className="flex items-center gap-2 mt-3">
            <button
              onClick={onInstall}
              data-testid="pwa-install-button"
              className="inline-flex items-center gap-1.5 bg-[#FF9800] hover:bg-[#E68900] text-white px-3 py-1.5 text-xs font-bold uppercase tracking-widest"
            >
              <DownloadSimple size={12} weight="bold" /> Install
            </button>
            <button
              onClick={onDismiss}
              data-testid="pwa-install-dismiss"
              className="text-[10px] font-bold uppercase tracking-widest text-zinc-400 hover:text-zinc-100"
            >
              Not now
            </button>
          </div>
        </div>
        <button
          onClick={onDismiss}
          aria-label="Close"
          className="p-1 text-zinc-500 hover:text-zinc-100 flex-shrink-0"
        >
          <X size={14} weight="bold" />
        </button>
      </div>
    </div>
  );
}
